import { getLanguage } from '$translation';

export function getDocumentHref(documentName: string, anchor?: string) {
  const currentLang = getLanguage();

  return `/${documentName}${currentLang === 'en' ? '_en' : ''}.html${
    anchor ? '#' + anchor : ''
  }`;
}
